import { FC, useMemo, useState } from "react";
import MileageUpdateVehicleType from "../../types/mileage-update-vehicle-type";
import mileageTranslationsHelper from "../../../../../../languages/mileage-translations.helper";
import { useAppContext } from "../../../../../../context/app.context";
import mileageUpdateVehicleTypeSelectOptionFactory from "../../factory/mileage-update-vehicle-type-select-option.factory";
import SingleSelectComponent from "../../../../../../common/components/form/select/single-select/single-select.component";
import MileageUpdateVehicleTypeSelectOption from "../../types/mileage-update-vehicle-type-select-option";

type MileageUpdateVehicleTypeSelectProps = {
  vehicleType: MileageUpdateVehicleType;
  onVehicleTypeChange: (type: MileageUpdateVehicleType) => void;
  onBlur?: () => void;
};

const MileageUpdateVehicleTypeSelectComponent: FC<
  MileageUpdateVehicleTypeSelectProps
> = (props) => {
  const translations =
    mileageTranslationsHelper.getMileageUpdateTranslations().vehicleType;

  const { selectedAppLanguage } = useAppContext();

  const [searchQuery, setSearchQuery] = useState("");

  const vehicleTypeSelectOptions = useMemo(
    mileageUpdateVehicleTypeSelectOptionFactory.createSelectOptions,
    [selectedAppLanguage]
  );

  const vehicleTypeSelectOption =
    mileageUpdateVehicleTypeSelectOptionFactory.createSelectOption(
      props.vehicleType
    );

  return (
    <SingleSelectComponent
      placeholder={translations.selectPlaceholder}
      value={vehicleTypeSelectOption}
      options={vehicleTypeSelectOptions}
      onChange={(value: MileageUpdateVehicleTypeSelectOption | null) => {
        if (!value) {
          return;
        }

        props.onVehicleTypeChange(value.value);
      }}
      idForTesting="mileage-update-vehicle-type-select-component"
      isSearchable
      inputValue={searchQuery}
      onInputChange={setSearchQuery}
      onBlur={props.onBlur}
    />
  );
};

export default MileageUpdateVehicleTypeSelectComponent;
